import axios from 'axios'

const StatusPagamentoAPI = {
  getStatusPagamento: async () => {
    const url = `https://api-imagens.agendeiquadras.com.br/utils/status.json?t=${new Date().getTime()}`
    try {
      const response = await axios.get(url)
      return response.data
    } catch (e) {
      return { error: true, message: e.message, erro: e }
    }
  },
}

export default StatusPagamentoAPI
